import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthGate } from "@/components/AuthGate";
import { SearchView } from "@/components/SearchView";

const searchSchema = z.object({
  q: z.string().optional().catch(undefined),
  kind: z.enum(["file", "folder"]).optional().catch(undefined),
});

export const Route = createFileRoute("/search")({
  validateSearch: (raw): z.infer<typeof searchSchema> =>
    searchSchema.parse(raw),
  component: function SearchPage() {
    const { q, kind } = Route.useSearch();
    return (
      <AuthGate>
        <SearchView q={q ?? ""} kind={kind} />
      </AuthGate>
    );
  },
});
